module.exports = __webpack_public_path__ + "static/media/HallA.68d0c0da.jpg";